// import React, { useState } from "react";
// import { Country, State, City } from "country-state-city";
// import { setRef } from "@mui/material";

// const CommonFields = ({
//   values,
//   setValues,
//   requiredFields,
//   errors,
//   setErrors,
//   fields = [],
// }) => {
//   const [showReferralInput, setShowReferralInput] = useState(
//     values.referalRadio === "yes",
//   );

//   const [showResumeUpload, setShowResumeUpload] = useState(
//     values.resumeRadio === "yes",
//   );

//   const handleChange = (field, value) => {
//     let updatedValues = { ...values, [field]: value };

//     // Reset state & city properly (same logic)
//     if (field === "country") {
//       updatedValues.state = "";
//       updatedValues.city = "";
//     } else if (field === "state") {
//       updatedValues.city = "";
//     }

//     setValues(updatedValues);

//     // Validation logic (same as before)
//     if (requiredFields.includes(field)) {
//       if (!value) {
//         setErrors((prev) => ({
//           ...prev,
//           [field]: "This field is required",
//         }));
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [field]: "",
//         }));
//       }
//     }

//     if (field === "email" && value) {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       if (!emailRegex.test(value)) {
//         setErrors((prev) => ({
//           ...prev,
//           email: "Invalid email address",
//         }));
//       }
//     }

//     if (field === "phone" && value) {
//       const phoneRegex = /^[0-9]{10,15}$/;
//       if (!phoneRegex.test(value)) {
//         setErrors((prev) => ({
//           ...prev,
//           phone: "Invalid phone number",
//         }));
//       }
//     }
//   };

//   const renderLabel = (label, field) => (
//     <>
//       {label}
//       {requiredFields.includes(field) && (
//         <span className="text-danger"> *</span>
//       )}
//     </>
//   );

//   return (
//     <>
//       <div className="row mb-2">
//         {/* First Name */}
//         {fields.includes("firstName") && (
//           <div className="col-md-6">
//             <label>{renderLabel("First Name", "firstName")}</label>
//             <input
//               className="form-control"
//               value={values.firstName}
//               onChange={(e) => handleChange("firstName", e.target.value)}
//             />
//             <small className="text-danger">{errors.firstName}</small>
//           </div>
//         )}

//         {/* Last Name */}
//         {fields.includes("lastName") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Last Name", "lastName")}</label>
//             <input
//               className="form-control"
//               value={values.lastName}
//               onChange={(e) => handleChange("lastName", e.target.value)}
//             />
//             <small className="text-danger">{errors.lastName}</small>
//           </div>
//         )}
//       </div>

//       <div className="row mb-2">
//         {/* Email */}
//         {fields.includes("email") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Email", "email")}</label>
//             <input
//               className="form-control"
//               value={values.email}
//               onChange={(e) => handleChange("email", e.target.value)}
//             />
//             <small className="text-danger">{errors.email}</small>
//           </div>
//         )}

//         {/* Phone */}
//         {fields.includes("phone") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Phone", "phone")}</label>
//             <input
//               className="form-control"
//               value={values.phone}
//               onChange={(e) => handleChange("phone", e.target.value)}
//             />
//             <small className="text-danger">{errors.phone}</small>
//           </div>
//         )}
//       </div>

//       <div className="row mb-2">
//         {/* DOB */}
//         {fields.includes("dob") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Date of Birth", "dob")}</label>
//             <input
//               type="date"
//               className="form-control"
//               value={values.dob}
//               onChange={(e) => handleChange("dob", e.target.value)}
//             />
//             <small className="text-danger">{errors.dob}</small>
//           </div>
//         )}

//         {/* Address */}
//         {fields.includes("address") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Street Address", "address")}</label>
//             <input
//               className="form-control"
//               value={values.address}
//               onChange={(e) => handleChange("address", e.target.value)}
//             />
//             <small className="text-danger">{errors.address}</small>
//           </div>
//         )}
//       </div>

//       <div className="row mb-2">
//         {/* Country */}
//         {fields.includes("country") && (
//           <div className="col-md-6">
//             <label>{renderLabel("Country", "country")}</label>
//             <select
//               className="form-select"
//               value={values.country}
//               onChange={(e) => handleChange("country", e.target.value)}
//             >
//               <option value="">-- Select Country --</option>
//               {Country.getAllCountries().map((c) => (
//                 <option key={c.isoCode} value={c.name}>
//                   {c.name}
//                 </option>
//               ))}
//             </select>
//             <small className="text-danger">{errors.country}</small>
//           </div>
//         )}

//         {/* State */}
//         {fields.includes("state") && (
//           <div className="col-md-6">
//             <label>{renderLabel("State", "state")}</label>
//             <select
//               className="form-select"
//               value={values.state}
//               onChange={(e) => handleChange("state", e.target.value)}
//               disabled={!values.country}
//             >
//               <option value="">-- Select State --</option>
//               {values.country &&
//                 State.getStatesOfCountry(
//                   Country.getAllCountries().find(
//                     (c) => c.name === values.country,
//                   )?.isoCode,
//                 ).map((s) => (
//                   <option key={s.isoCode} value={s.name}>
//                     {s.name}
//                   </option>
//                 ))}
//             </select>
//             <small className="text-danger">{errors.state}</small>
//           </div>
//         )}
//       </div>

//       <div className="row mb-2">
//         {/* City */}
//         {fields.includes("city") && (
//           <div className="col-md-6">
//             <label>{renderLabel("City", "city")}</label>
//             <select
//               className="form-select"
//               value={values.city}
//               onChange={(e) => handleChange("city", e.target.value)}
//               disabled={!values.state}
//             >
//               <option value="">-- Select City --</option>
//               {values.country &&
//                 values.state &&
//                 City.getCitiesOfState(
//                   Country.getAllCountries().find(
//                     (c) => c.name === values.country,
//                   )?.isoCode,
//                   State.getStatesOfCountry(
//                     Country.getAllCountries().find(
//                       (c) => c.name === values.country,
//                     )?.isoCode,
//                   ).find((s) => s.name === values.state)?.isoCode,
//                 ).map((c) => (
//                   <option key={c.name} value={c.name}>
//                     {c.name}
//                   </option>
//                 ))}
//             </select>
//             <small className="text-danger">{errors.city}</small>
//           </div>
//         )}
//       </div>

//       {/* Referral Section */}
//       {fields.includes("referalRadio") && (
//         <div className="mb-2">
//           <label>
//             {renderLabel("Were you referred by someone?", "referalRadio")}
//           </label>
//           <div>
//             <input
//               type="radio"
//               value="yes"
//               checked={values.referalRadio === "yes"}
//               onChange={(e) => {
//                 handleChange("referalRadio", e.target.value);
//                 setShowReferralInput(true);
//               }}
//             />{" "}
//             Yes
//             <input
//               type="radio"
//               value="no"
//               className="ms-3"
//               checked={values.referalRadio === "no"}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 handleChange("referalRadio", value);
//                 setShowReferralInput(false);

//               }}
//             />{" "}
//             No
//           </div>
//         </div>
//       )}

//       {fields.includes("referralName") && showReferralInput && (
//         <div className="mb-2">
//           <label>{renderLabel("Referral Name", "referralName")}</label>
//           <input
//             className="form-control"
//             value={values.referralName || ""}
//             onChange={(e) => handleChange("referralName", e.target.value)}
//           />
//           <small className="text-danger">{errors.referralName}</small>
//         </div>
//       )}

//       {/* Resume Section */}
//       {fields.includes("resumeRadio") && (
//         <div className="mb-2">
//           <label>
//             {renderLabel("Do you have a resume?", "resumeRadio")}
//           </label>
//           <div>
//             <input
//               type="radio"
//               value="yes"
//               checked={values.resumeRadio === "yes"}
//               onChange={(e) => {
//                 handleChange("resumeRadio", e.target.value);
//                 setShowResumeUpload(true);
//               }}
//             />{" "}
//             Yes
//             <input
//               type="radio"
//               value="no"
//               className="ms-3"
//               checked={values.resumeRadio === "no"}
//               onChange={(e) => {
//                 handleChange("resumeRadio", e.target.value);
//                 setShowResumeUpload(false);
//               }}
//             />{" "}
//             No
//           </div>
//         </div>
//       )}

//       {fields.includes("resumeFile") && showResumeUpload && (
//         <div className="mb-2">
//           <label>{renderLabel("Upload Resume", "resumeFile")}</label>
//           <input
//             type="file"
//             className="form-control"
//             onChange={(e) => handleChange("resumeFile", e.target.files[0])}
//           />
//           <small className="text-danger">{errors.resumeFile}</small>
//         </div>
//       )}
//     </>
//   );
// };

// export default CommonFields;

import React, { useState } from "react";
import { Country, State, City } from "country-state-city";
import { showErrorToast } from "../toast";
import { useRef } from "react";

const CommonFields = ({
  values,
  setValues,
  requiredFields,
  errors,
  setErrors,
  fields = [],
  resumeInputRef,
}) => {
  const showResumeUpload = values.resumeRadio === "yes";
  const showReferralInput = values.referalRadio === "yes";

  const handleChange = (field, value) => {
    let updatedValues = { ...values, [field]: value };

    // Reset dependent fields when a parent changes
    if (field === "hasDegree") {
      if (value === "no") {
        updatedValues.degree = "";
        updatedValues.graduationYear = "";
      }
    }

    if (field === "hasExperience") {
      if (value === "no") {
        updatedValues.experience = "";
        updatedValues.companyName = "";
      }
    }

    if (field === "referalRadio") {
      if (value === "no") {
        updatedValues.referralName = "";
      }
    }

    if (field === "resumeRadio") {
      if (value === "no") {
        updatedValues.resumeFile = null;
        if (resumeInputRef.current) resumeInputRef.current.value = "";
      }
    }

    // Reset dependent fields
    if (field === "country") {
      updatedValues.state = "";
      updatedValues.city = "";
      updatedValues.location = ""
    } else if (field === "state") {
      updatedValues.city = "";
      updatedValues.location = ""
    }

    if (field === "city") {
      updatedValues.city = value;
      updatedValues.location = "";
    }

    if (field === "location") {
      updatedValues.location = value;

    }


    //  Single state update
    setValues(updatedValues);

    // Clear errors dynamically
    setErrors((prev) => {
      let newErrors = { ...prev };

      // Required field check
      if (requiredFields.includes(field) && value) {
        delete newErrors[field];
      }

      if (field == "location" && value) {
        delete newErrors[field];
      }



      // Conditional fields
      if (field === "degree" || field === "graduationYear") {
        if (values.hasDegree === "yes" && value) delete newErrors[field];
      }
      if (field === "experience" || field === "remarks") {
        if (values.hasExperience === "yes" && value) delete newErrors[field];
      }

      // Email validation
      if (field === "email") {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
        if (emailRegex.test(value)) {
          delete newErrors.email;
        } else if (value) {
          newErrors.email = "Invalid email address";
        }
      }

      // Phone validation
      if (field === "phone") {
        const phoneRegex = /^\+?[0-9]{10,15}$/;
        if (phoneRegex.test(value)) {
          delete newErrors.phone;
        } else if (value) {
          newErrors.phone = "Invalid phone number";
        }
      }



      return newErrors;
    });
  };

  const renderLabel = (label, field) => (
    <>
      {label}
      {requiredFields.includes(field) && (
        <span className="text-danger"> *</span>
      )}
    </>
  );

  return (
    <>
      <div className="row mb-1">
        {/* First Name */}
        {fields.includes("firstName") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Your Name (First Name)", "firstName")}</label>
            <input
              className="form-control"
              value={values.firstName}
              onChange={(e) => handleChange("firstName", e.target.value)}
            />
            <small className="text-danger">{errors.firstName}</small>
          </div>
        )}

        {/* Last Name */}
        {fields.includes("lastName") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Initials Expansion (Last Name)", "lastName")}</label>
            <input
              className="form-control"
              value={values.lastName}
              onChange={(e) => handleChange("lastName", e.target.value)}
            />
            <small className="text-danger">{errors.lastName}</small>
          </div>
        )}
      </div>

      <div className="row mb-1">
        {/* Email */}
        {fields.includes("email") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Email", "email")}</label>
            <input
              className="form-control"
              value={values.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
            <small className="text-danger">{errors.email}</small>
          </div>
        )}

        {/* Phone */}
        {fields.includes("phone") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Phone", "phone")}</label>
            <input
              className="form-control"
              value={values.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
            <small className="text-danger">{errors.phone}</small>
          </div>
        )}
      </div>
      <div className="row mb-1">
        {/* Country */}
        {fields.includes("country") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Country", "country")}</label>
            <select
              className="form-select"
              value="India" // fixed value
              disabled //  not editable
            >
              <option value="India">India</option>
            </select>
            <small className="text-danger">{errors.country}</small>
          </div>
        )}

        {fields.includes("state") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("State", "state")}</label>
            <select
              className="form-select"
              value={values.state}
              onChange={(e) => handleChange("state", e.target.value)}
            >
              <option value="">-- Select State --</option>
              {values.country &&
                State.getStatesOfCountry(
                  Country.getAllCountries().find(
                    (c) => c.name === values.country,
                  )?.isoCode,
                ).map((s) => (
                  <option key={s.isoCode} value={s.name}>
                    {s.name}
                  </option>
                ))}
            </select>
            <small className="text-danger">{errors.state}</small>
          </div>
        )}
      </div>


      <div className="row mb-1">
        {/* City */}
        {fields.includes("city") && (
          <div
            className={`${values.city === "Others" ? "col-md-6 col-12" : "col-md-12 col-12"
              }`}
          >
            <label>{renderLabel("City", "city")}</label>
            <select
              className="form-select"
              value={values.city}
              onChange={(e) => handleChange("city", e.target.value)}
            >
              <option value="">-- Select City --</option>
              <option value="Others">Others</option>
              {values.country &&
                values.state &&
                City.getCitiesOfState(
                  Country.getAllCountries().find(
                    (c) => c.name === values.country
                  )?.isoCode,
                  State.getStatesOfCountry(
                    Country.getAllCountries().find(
                      (c) => c.name === values.country
                    )?.isoCode
                  ).find((s) => s.name === values.state)?.isoCode
                ).map((c) => (
                  <option key={c.name} value={c.name}>
                    {c.name}
                  </option>
                ))}


            </select>

            <small className="text-danger">{errors.city}</small>
          </div>
        )}

        {/* Location (only when Others selected) */}
        {values.city === "Others" && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Location", "location")} <span className="text-danger"> *</span></label>
            <input
              className="form-control"
              value={values.location}
              onChange={(e) => handleChange("location", e.target.value)}
            />
            <small className="text-danger">{errors.location}</small>
          </div>
        )}
      </div>

      {/* Degree */}

      {/* {fields.includes("hasDegree") && (
        <div className="mb-2">
          <label>{renderLabel("Do you have a degree?", "hasDegree")}</label>
          <div>
            <input
              type="radio"
              value="yes"
              checked={values.hasDegree === "yes"}
              onChange={(e) => handleChange("hasDegree", e.target.value)}
            />{" "}
            Yes
            <input
              type="radio"
              value="no"
              className="ms-3"
              checked={values.hasDegree === "no"}
              onChange={(e) => handleChange("hasDegree", e.target.value)}
            />{" "}
            No
          </div>
        </div>
      )} */}

      <div className="row mb-1">
        {/* Address */}
        {fields.includes("address") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Street Address", "address")}</label>
            <input
              className="form-control"
              value={values.address}
              onChange={(e) => handleChange("address", e.target.value)}
            />
            <small className="text-danger">{errors.address}</small>
          </div>
        )}
        {fields.includes("degree") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Degree", "degree")}</label>
            <input
              className="form-control"
              value={values.degree}
              onChange={(e) => handleChange("degree", e.target.value)}
            />
            <small className="text-danger">{errors.degree}</small>
          </div>
        )}


      </div>

      <div className="row mb-1">
        {fields.includes("graduationYear") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Graduation Year", "graduationYear")}</label>
            <input
              className="form-control"
              type="number"
              value={values.graduationYear}
              onChange={(e) => handleChange("graduationYear", e.target.value)}
            />
            <small className="text-danger">{errors.graduationYear}</small>
          </div>
        )}
        {/* Job Type */}
        {fields.includes("jobType") && (
          <div className="col-md-6 col-12">
            <label>{renderLabel("Job Type", "jobType")}</label>
            <select
              className="form-select"
              value={values.jobType}
              onChange={(e) => handleChange("jobType", e.target.value)}
            >
              <option value="">-- Select Job Type --</option>
              <option value="Software Analyst / Developer">
                Software Analyst / Developer
              </option>
              <option value="IT Infrastructure / System Admin">
                IT Infrastructure / System Admin
              </option>
              <option value="DevOps Specialist">DevOps Specialist</option>
              <option value="IT Trainer (Special Role)">
                IT Trainer (Special Role)
              </option>
            </select>
            <small className="text-danger">{errors.jobType}</small>
          </div>
        )}
      </div>

      {fields.includes("resumeFile") && (
        <div >
          <label className="form-label">
            {renderLabel("Upload Resume", "resumeFile")}
          </label>
          <input
            type="file"
            className="form-control"
            title="Allowed file types: .pdf, .doc, .docx"
            accept=".pdf,.doc,.docx" // only allow PDF/DOC/DOCX
            ref={resumeInputRef} // attach ref
            onChange={(e) => {
              const file = e.target.files[0];
              const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

              if (file) {
                const allowedTypes = [
                  "application/pdf",
                  "application/msword",
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                ];
                if (!allowedTypes.includes(file.type)) {
                  handleChange("resumeFile", null);
                  showErrorToast(
                    "Invalid file type. Only PDF, DOC, DOCX allowed.",
                  );
                  if (resumeInputRef.current)
                    resumeInputRef.current.value = "";
                } else if (file.size > maxSizeInBytes) {
                  handleChange("resumeFile", null);
                  showErrorToast("File size exceeds 5 MB.");
                  if (resumeInputRef.current)
                    resumeInputRef.current.value = "";
                } else {
                  handleChange("resumeFile", file);
                }
              }
            }}
          />
          <small className="text-danger">{errors.resumeFile}</small>
        </div>
      )}

      {/* Experience */}
      {fields.includes("hasExperience") && (
        <div className="mb-2">
          <label>
            {renderLabel("Do you have work experience?", "hasExperience")}
          </label>
          <div>
            <input
              type="radio"
              value="yes"
              checked={values.hasExperience === "yes"}
              onChange={(e) => handleChange("hasExperience", e.target.value)}
            />{" "}
            Yes
            <input
              type="radio"
              value="no"
              className="ms-3"
              checked={values.hasExperience === "no"}
              onChange={(e) => handleChange("hasExperience", e.target.value)}
            />{" "}
            No
          </div>
        </div>
      )}

      {values.hasExperience === "yes" && (
        <div className="row mb-1">
          <div className="col-md-6 col-12">
            <label>{renderLabel("Years of Experience", "experience")}</label>
            <input
              className="form-control"
              type="number"
              value={values.experience}
              onChange={(e) => handleChange("experience", e.target.value)}
            />
            <small className="text-danger">{errors.experience}</small>
          </div>
          <div className="col-md-6 col-12">
            <label>{renderLabel("Remarks", "remarks")}</label>
            <input
              className="form-control"
              value={values.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
            <small className="text-danger">{errors.remarks}</small>
          </div>
        </div>
      )}

      <div className="row mb-1 mt-2">
        {fields.includes("referalRadio") && (
          <div className="mb-2">
            <label>
              {renderLabel("Were you referred by someone?", "referalRadio")}
            </label>
            <div>
              <input
                type="radio"
                value="yes"
                checked={values.referalRadio === "yes"}
                onChange={(e) => {
                  handleChange("referalRadio", e.target.value);
                }}
              />{" "}
              Yes
              <input
                type="radio"
                value="no"
                className="ms-3"
                checked={values.referalRadio === "no"}
                onChange={(e) => {
                  const value = e.target.value;
                  handleChange("referalRadio", value);
                }}
              />{" "}
              No
            </div>
          </div>
        )}
        {fields.includes("referralName") && showReferralInput && (
          <div>
            <label className="form-label">
              {renderLabel("Referral Name", "referralName")}
            </label>
            <input
              className="form-control width-100"
              value={values.referralName}
              onChange={(e) => handleChange("referralName", e.target.value)}
            />
            <small className="text-danger">{errors.referralName}</small>
          </div>
        )}


      </div>
    </>
  );
};

export default CommonFields;
